export const getWebpCoverURL = (url: string) => {
  if (/(.jpg|.jpeg)$/gm.exec(url) === null) {
    throw new Error("Incorrect image extension. Expected jpg or jpeg");
  }
  return url.replace(/(.jpg|.jpeg)$/gm, ".webp");
};
